interface ChatHistoryRequest {
  app_id: string;
  user_id: string;
  date_range: {
    start_date: string | null;
    end_date: string | null;
  };
  pagination: {
    pageSize: number;
    skip: number;
    searchTerm: string;
    sortBy: string;
    sortOrder: 'asc' | 'desc';
  };
}

export const fetchChatHistory = async (request:ChatHistoryRequest) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/chat-history/threads`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
  
    });
    return await response.json();
};

export const fetchMessage = async (app_id: string, thread_id: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/chat-history/messages`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ app_id , thread_id}),

  });
  return await response.json();
};

export const fetchUsers = async (app_id: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/chat-history/users`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ app_id }),

  });
  return await response.json();
};

export const deleteChat = async (app_id: string, thread_id: string) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/chat-history/threads/${thread_id}?app_id=${app_id}`,
    {
      method: "DELETE", // Use DELETE instead of POST
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to delete chat thread");
  }

  return await response.json();
};
export const exportChat = async (request:ChatHistoryRequest) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/chat-history/export`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),

  });
  return await response.json();
};